import * as angular from "angular";
import { EventModel } from "../../models/event.model";
import { PermissionCheck } from "../../shared/permission";
import { DialogUtils } from "../../helper/dialog.helper";
import { ScreenUtils } from "../../helper/screen.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { EventDataProvider } from "../../data-provider/event.dp";
import { Utils } from "../../helper/utils.helper";

let EventInfoComponent = {
    selector: "vcEventInfo",
    templateUrl: "/angular/components/event/event-info.component.html",
    bindings: {},
    controller: class EventInfoController {
        public id: number | string;
        public event: EventModel;
        public eventError = false;
        public rsvp: any;

        private $location: any;
        private dialog: DialogUtils;
        private toast: ToastUtils;
        public utils: Utils;
        public screen: ScreenUtils;

        private dataProvider: EventDataProvider;
        public permissionProvider: PermissionCheck;

        constructor(
            $location: any,
            $routeParams: any,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            Utils: Utils,
            ScreenUtils: ScreenUtils,
            EventDataProvider: EventDataProvider,
            PermissionCheck: PermissionCheck
        ) {
            this.$location = $location;
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
            this.utils = Utils;
            this.screen = ScreenUtils;

            this.dataProvider = EventDataProvider;
            this.permissionProvider = PermissionCheck;

            this.id = $routeParams.id;

            this.dataProvider.info(this.id).then(
                (event: EventModel) => (this.event = event),
                () => (this.eventError = true)
            );

            this.dataProvider
                .getRsvp(this.id)
                .then((rsvp: any) => (this.rsvp = rsvp));
        }

        cancelEvent(event: EventModel): void {
            this.dialog
                .delete({
                    fullscreen: true,
                    skipHide: true,
                    locals: {
                        bodyText: "They will be permanently cancelled",
                        title: "Cancel Action?",
                        buttonText: {
                            cancel: "No",
                            confirm: "Yes",
                        },
                    },
                })
                .then(() => {
                    this.dataProvider.cancel(event).then(
                        () => {
                            this.$location.url("/events");
                            this.toast.success("Action cancelled");
                        },
                        () => this.toast.error()
                    );
                });
        }
    },
};

angular
    .module("event")
    .component(EventInfoComponent.selector, EventInfoComponent);
